module.exports = __webpack_public_path__ + "static/media/saved_transitional_marker.d1e2c3ad.svg";